export default {
	message: 'snackbar-message',
};
